import * as React from 'react';
import { LabelContext, } from './label-provider';
const useLabels = () => {
    return React.useContext(LabelContext);
};
export { useLabels };
